export default __webpack_public_path__ + "static/media/description_0.543beed0.svg";